<template>
  <section class="contact-us container">
    <ModalForm
        :modal="modal"
        :show="showModalForm"
        :successModalData="successModalData"
        @handle-modal="handleFormInModal"
    />
    <div class="row align-items-center">
      <div class="col-4 d-none d-lg-flex justify-content-center">
        <img :src="contacts.img.link" :alt="contacts.img.alt" width="326" height="326">
      </div>
      <div class="col-12 col-lg-8">
        <h2>{{ contacts.title }}</h2>
        <div v-html="contacts.description"></div>
        <div class="row flex-md-nowrap">
          <template v-for="button in contacts.buttons" :key="button.id">
            <RedCircle class="red-circle-container w-auto" hyperlink :href="button.link" :text="button.title" v-if="button.link">
              <span v-html="button.icon" />
            </RedCircle>
            <RedCircle class="red-circle-container w-auto" :text="button.title" @click="handleFormInModal" v-else>
              <span v-html="button.icon" />
            </RedCircle>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ModalForm from "@/components/common/modals/ModalForm.vue";
import RedCircle from "@/components/common/RedCircle";
import {ref} from "vue";

defineProps({
  contacts: {
    title: String,
    description: HTMLElement,
    img: {
      link: String,
      alt: String,
    },
    buttons: Array
  },
  modal: Object,
  successModalData: Object
})

const showModalForm = ref(false)

const handleFormInModal = () =>
    showModalForm.value = !showModalForm.value
</script>
